// extracted by mini-css-extract-plugin
module.exports = {"prescription_slider":"styles_prescription_slider__Pptsi","next":"styles_next__Ex4WU","previous":"styles_previous__Da8UV"};